import React from 'react';
import LiveProgramsListingPage from './LiveProgramsListingPage';
export default function LiveWebinarsPage() { return <LiveProgramsListingPage type="webinar"/>; }
